import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'comment', 'approve', 'reject'];

  connect() {
    this.reset();
  }

  evaluate() {
    console.log('evaluate');
    let vals = this.inputTargets.map((x) => x.value);

    if (vals.includes('no')) {
      this.disableApprove();
      this.enableReject();
      this.requireComment();
      return;
    }

    if (vals.includes('acceptable')) {
      this.enableApprove();
      this.enableReject();
      this.requireComment();
      return;
    }

    if (vals.includes('') || vals.includes(null)) {
      this.disableApprove();
      this.requireComment();
    } else {
      this.enableApprove();
      this.unrequireComment();
      this.disableReject();
    }
  }

  reset() {
    this.disableApprove();
    this.disableReject();
  }

  requireComment() {
    this.commentTarget.required = true;
  }

  unrequireComment() {
    this.commentTarget.required = false;
  }

  disableApprove() {
    this.approveTarget.disabled = true;
    this.approveTarget.classList.add('opacity-20');
  }
  disableReject() {
    this.rejectTarget.disabled = true;
    this.rejectTarget.classList.add('opacity-20');
  }

  enableApprove() {
    this.approveTarget.enabled = true;
    this.approveTarget.disabled = false;
    this.approveTarget.classList.remove('opacity-20');
  }
  enableReject() {
    this.rejectTarget.enabled = true;
    this.rejectTarget.disabled = false;
    this.rejectTarget.classList.remove('opacity-20');
  }

  canApprove() {
    return false;
  }

  canReject() {
    return false;
  }

  approve() {
    if (!this.canApprove()) {
    }
  }

  reject() {
    if (!this.canReject()) {
    }
  }
}
